import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../providers/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  userId: any;// $routeParams["user_id"];
  state: any;// $routeParams["state"];
  error: boolean = false;

  path: any; // this.user.getCurrentPath();

  constructor(private user: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private translateService: TranslateService) { }

  ngOnInit(): void {
    this.userId = this.route.snapshot.queryParams['user_id'];
    this.state = this.route.snapshot.queryParams['state'];

    if (this.userId === "_") this.user.saveUserId(null);
    else this.user.saveUserId(this.userId);

    this.path = this.user.getCurrentPath(this.state);


    if (this.path.state && this.path.state === this.state) {
      window.location.assign(this.path.path)
    } else {
      //$location.path("/");
      this.router.navigate(['/'], {});
    }


  }

}
